import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './NavigationBeforeLogin.css';
import { Nav, NavDropdown } from 'react-bootstrap';

//Redux
import { connect } from 'react-redux';

// Modals
import LoginModal from '../LoginModal';
import SignupModal from '../SignupModal';
import ForgotPassword from '../ForgotPassword';
import HeaderModal from '../HeaderModal';
import NavLink from '../NavLink';

// Locale
import messages from '../../locale/messages';
import DropDownMenu from '../DropDownMenu/DropDownMenu';
import { openHeaderModal } from '../../actions/modalActions';

// Helpers
import { showCurrencySymbol } from '../../helpers/currencyConvertion';
import { formatLocale } from '../../helpers/formatLocale';

// Images - Legacy icons
import currencyIcon from '/public/SiteIcons/currencyIcon.svg';
import currencyIconTwo from '/public/SiteIcons/currencyIconTwo.svg';

class NavigationBeforeLogin extends React.Component {

  static propTypes = {
    className: PropTypes.string,
    setUserLogout: PropTypes.any,
    openLoginModal: PropTypes.any,
    openSignupModal: PropTypes.any,
  };

  render() {
    const { className, openLoginModal, openSignupModal, openHeaderModal, homeHeaderOnly } = this.props;
    const { toCurrency, baseCurrency, currentLocale, openClose, layoutType, becomeHeader } = this.props;
    let displayCurrency = toCurrency ? toCurrency : baseCurrency;

    return (
      <div>
        <LoginModal />
        <SignupModal />
        <ForgotPassword />
        <HeaderModal />

        {/* Mobile Menu - Visible on small screens */}
        <div className={cx(s.mobileNavContainer, 'visible-xs')}>
          <NavLink
            noLink
            onClick={(e) => openHeaderModal('languageModal')}
            className={s.mobileNavItem}
          >
            <FormattedMessage {...messages.languageAndCurrency} />
          </NavLink>
          <NavLink
            noLink
            onClick={openLoginModal}
            className={s.mobileNavItem}
          >
            <FormattedMessage {...messages.login} />
          </NavLink>
          <NavLink
            noLink
            onClick={openSignupModal}
            className={s.mobileNavItem}
          >
            <FormattedMessage {...messages.signup} />
          </NavLink>
          <NavLink to="/help" className={s.mobileNavItem}>
            <FormattedMessage {...messages.help} />
          </NavLink>
        </div>

        {/* Desktop Menu - Hidden on small screens */}
        <Nav pullRight className={cx('normalHeader', s.navFlexContainer, 'hidden-xs')}>
          {/* Botón Publica tu bote - glassmorphic */}
          {homeHeaderOnly &&
            <div className={cx(s.publishButton, 'hidden-md', 'hidden-sm')}>
              <NavLink to="/become-a-owner?mode=new">
                <FormattedMessage {...messages.becomeAHost} />
              </NavLink>
            </div>
          }
          {/* Icono Idiomas - Legacy SVG */}
          <NavLink
            noLink
            onClick={(e) => openHeaderModal('languageModal')}
            className={cx('hidden-md', s.nonBreakPointScreen)}
          >
            {homeHeaderOnly && <img src={currencyIcon} alt="Language" />}
            {!homeHeaderOnly && <img src={currencyIconTwo} alt="Language" />}
          </NavLink>

          {/* Menú Usuario con Dropdown */}
          <NavDropdown
            className={cx(s.nonBreakPointScreen)} eventKey={3} title={
              <DropDownMenu homeHeaderOnly={homeHeaderOnly} />
            } noCaret id="basic-nav-dropdown"
          >
            <NavLink to="#" noLink onClick={openLoginModal} >
              <FormattedMessage {...messages.login} />
            </NavLink>
            <NavLink to="#" noLink onClick={openSignupModal}>
              <FormattedMessage {...messages.signup} />
            </NavLink>
            <NavLink to="/help">
              <FormattedMessage {...messages.help} />
            </NavLink>
          </NavDropdown>
        </Nav>
      </div>
    );
  }

}

const mapState = state => ({
  baseCurrency: state.currency.base,
  toCurrency: state.currency.to,
  currentLocale: state.intl.locale,
  layoutType: state.siteSettings?.data?.homePageType || 1
});
const mapDispatch = {
  openHeaderModal
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(NavigationBeforeLogin)));
